import { ChangeDetectorRef, Component, EventEmitter, HostListener, Input, OnInit, Output, ViewChild } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { registerLocaleData } from '@angular/common';
import es from '@angular/common/locales/es';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MultipleValidator } from '../invest-multiple.validator';
import { ToastService } from '../../toast/toast.service';
import { InputComponent } from '../../input/input.component';
import { BiometricService } from 'src/app/services/biometric.service';
import { ProfileService } from 'src/app/services/profile.service';
import { UtilsService } from 'src/app/services/utils.service';
import { environment } from 'src/environments/environment';
import { OveralMessageComponent } from '../../overal-message/overal-message.component';
import { AlertService } from '../../alert/alert.service';
import { StrapiService } from 'src/app/services/strapi.service';

@Component({
  selector: 'app-invest-body',
  templateUrl: './invest-body.component.html',
  styleUrls: ['./invest-body.component.scss'],
})
export class InvestBodyComponent implements OnInit {
  @ViewChild('inputAmount', { static: false }) inputAmountRef: InputComponent;
  @Output() public moneyToInvest = new EventEmitter<any>();
  @Output() public setPayType = new EventEmitter<any>();
  @Output() public setCodePromotion = new EventEmitter<any>();
  @Output() public amountValue = new EventEmitter<any>();
  @Output() public localInvestIdEvent = new EventEmitter<any>();
  @Output() public addPromotionalMoneyEvent = new EventEmitter<any>();
  @Output() public openTestEvent = new EventEmitter<any>();
  @Output() public closeAndCheckIbanEvent = new EventEmitter<any>();
  @Output() public hasToBookInvestmentEvent = new EventEmitter<any>();
  @Output() public userValidatedInPriorityGroupEvent = new EventEmitter<any>();
  @Input() data: any;
  @Input() errors: any;
  @Input() amount: any;
  @Input() localInvestProject: any;
  @Input() profile: any;

  public cashForm: FormGroup;
  public sharedForm: FormGroup;
  public formControlKeys = [];
  public errorMessages = {};
  public isSubmit = false;
  public errorCash = false;
  public sendXHR = 'colorFull-disabled';
  public disableInputs = false;
  public isOpen = false;
  public symbol: string;
  public method: number;
  public prevent = 0;
  moreTanAvailable: boolean;
  inputValue: any;
  ref: string;
  hasReferredCode: boolean;
  promoCode: string;

  sharedList = [];
  hasSharedList = false;
  sharedValue: number;
  hasSharedType: any;
  shareInfo: any;

  promotionalMoney = 0;
  totalMoney: number;
  addPromoChecked = false;
  pendingPromos = [];
  selectItm = 0;
  isInvestCommitment = false;
  reservedValue = 0;
  errorMaxAmount = false;
  hasEconomicRights: boolean;
  showAdvice = false;

  reservedMsg: string;
  hasReservedMoney = false;
  infoReserveData: any;
  refCode: any;
  refMessage: string;
  minInvestmentAllowed = 0;
  enablePayByCardMethod: boolean;

  /* 
    Conjunto de variables para caso especial en el cual tenemos una fase de financiacion reservada a clientes y empleados del promotor
    tras la inversión, hay que aplicar un tipo de participaciones diferente a estos usuarios
    pero el promotor se niega a facilitarnos los datos de dichos usuarios por los que debemos identificarlos nosotros en todas las fases
    ya que puede habber fases de inversión global
  */
  projectListWithEmployeeAndClientInvestmentPhase: any[];
  currentProjectHasEmployeeAndClientInvestmentPhase: any;
  currentProjectHasEmployeeAndClientInvestmentPhaseChecked: boolean = false;

  badgeGroupCreditCard = {
    "title": this.translate.instant('invest.Process.card'),
    "subtitle": this.translate.instant('INVEST.CARD_UNAVAILABLE'),
    "color": "primary",
    "theme": "light",
    "icon": "info-circle",
  }

  showStatkaftAdvise: boolean = false;
  isForeingInvestor: boolean = false;

  hasToBookInvestment: boolean = false;
  isPriorityGroupStep: boolean = false;
  userValidatedInPriorityGroup: boolean = false;
  priorityGroupForUser: any;
  currentStage: any;

  constructor(
    private chdRef: ChangeDetectorRef,
    public translate: TranslateService,
    public toastService: ToastService,
    private biometricService: BiometricService,
    private profileService: ProfileService,
    private utils: UtilsService,
    private alertService: AlertService,
    private strapiService: StrapiService
  ) {
    this.cashForm = new FormGroup({
      cash: new FormControl('', [Validators.required, Validators.min(1)]),
      promotion: new FormControl('', [Validators.minLength(1)]),
      stockPackageId: new FormControl('', [])
    });
    this.sharedForm = new FormGroup({
      shared: new FormControl('', [Validators.required])
    });
    this.formControlKeys = Object.keys(this.cashForm.controls);
    this.errorMessages = {
      min: this.translate.instant('input-errors-messages.incorrect-amount'),
      pattern: this.translate.instant('input-errors-messages.incorrect-amount'),
      required: this.translate.instant('input-errors-messages.required'),
    };
  }

  ngOnInit() {
    console.log(this.data, 'data');
    if (this.data['investmentStages'] && this.data['investmentStages'] !== undefined) {
      this.setStagesInfo();
    }
    if (this.profile['nationality'] !== 108 && this.profile['taxCountry'] !== 108) {
      this.isForeingInvestor = true;
    }
    this.enablePayByCardMethod = environment.enablePayByCardMethod;
    this.projectListWithEmployeeAndClientInvestmentPhase = environment.projectListWithEmployeeAndClientInvestmentPhase;
    this.currentProjectHasEmployeeAndClientInvestmentPhase = this.projectListWithEmployeeAndClientInvestmentPhase.find(project => project.projectId === this.data.id);
    if (this.data.status === 14 && this.amount === '') {
      this.amount = this.data.max_allowed_amount_to_invest_for_user.toString();
    }
    this.amount = this.amount.toString();
    // Con recompra las B
    this.isInvestCommitment = this.data.investCommitment ? true : false;
    if (this.data.reserved_list.length > 0) {
      this.data.reserved_list.forEach(element => {
        this.reservedValue = this.reservedValue + element.amount;
      });
    }
    if (this.reservedValue > 0) {
      this.reservedMsg = this.translate.instant('FORMALITIES.YOUR_RESERVE_TXT', { reservedValue: this.reservedValue });
      this.hasReservedMoney = true;
      this.amount = this.reservedValue.toString();
      this.infoReserveData = {
        txt: this.reservedMsg,
        btnTitle: this.translate.instant('AUTOINVEST.FOOTER.NEXT')
      }
      this.chdRef.detectChanges();
    }
    if (this.data.economicRights !== null && this.data.economicRights !== undefined && this.data.economicRights.length >= 1) {
      for (let i = 0; i < this.data.economicRights.length; i++) {
        let el: any = {};
        el.id = i;
        el.name = this.data.economicRights[i].description;
        el.id_element = this.data.economicRights[i].id;
        el.profitability = this.data.economicRights[i].profitability;
        el.can_operate_in_marketplace = this.data.economicRights[i].can_operate_in_marketplace;
        el.repurchase = this.data.economicRights[i].description.includes('B') ? true : false;
        el['long_description'] = this.data.economicRights[i].long_description;
        this.sharedList.push(el);
      }
      // Ordenar de menor a mayor según profitability para ofrecer de primeras por defecto la mas baja
      this.sharedList.sort((a, b) => a.profitability - b.profitability);

      this.shareInfo = this.sharedList[0];
      const model = {
        id: this.shareInfo.id_element,
        prof: this.shareInfo.profitability
      };
      this.localInvestIdEvent.emit(model);
      if (this.data.economicRights.length > 1) {
        this.hasEconomicRights = true;
        this.hasSharedList = true;
        this.localInvestProject = true;
        this.sendXHR = 'colorFull';
      } else {
        this.hasEconomicRights = false;
        this.localInvestProject = false;
      }
    } else {
      this.hasEconomicRights = false;
      this.localInvestProject = false;
    }

    this.promoCode = '';
    registerLocaleData(es);
    this.inputValue = this.amount;
    this.totalMoney = Number(this.inputValue) + this.promotionalMoney;
    this.symbol = ' + ';
    this.method = 2;
    this.calculate();
    this.hasReferredCode = (this.data.isFirstInvestment && this.checkValue(this.data.promotionalCode)) ? true : false;
    if (this.hasReferredCode) {
      this.isOpen = true;
      this.promoCode = this.data.promotionalCode;
      this.checkPromotionalCode(this.promoCode);
    }
    if (this.data.economicRights !== null && this.data.economicRights !== undefined && this.hasEconomicRights) {
      this.hasSharedType = true;
    } else {
      this.hasSharedType = false;
    }
    this.pendingPromos = this.data.pendingP;
    let sum = 0;
    for (let i = 0; i < this.pendingPromos.length; i++) {
      sum += this.pendingPromos[i].netAmount;
    }
    const sumParse = Number(sum.toFixed(2)); // Corrige error decimal de js
    this.promotionalMoney = Math.floor(sumParse);
    const payload = {
      promos: this.pendingPromos,
      add: this.addPromoChecked
    };
    this.addPromotionalMoneyEvent.emit(payload);
    this.checkEneableBtn();
    this.chdRef.detectChanges();
  }

  ngAfterViewInit() {
    this.controlBtn();
    this.chdRef.detectChanges();
  }

  ngOnChanges() {
    this.cashForm = new FormGroup({
      cash: new FormControl('',
        [Validators.required, MultipleValidator(this.data.allowedAmountModules), Validators.min(1)]),
      promotion: new FormControl('', [Validators.minLength(1)]),
      stockPackageId: new FormControl('', [])
    });
    this.formControlKeys = Object.keys(this.cashForm.controls);
    this.errorMessages = {
      min: this.translate.instant('input-errors-messages.incorrect-amount'),
      max: this.translate.instant('input-errors-messages.incorrect-amount'),
      pattern: this.translate.instant('input-errors-messages.incorrect-amount'),
      required: this.translate.instant('input-errors-messages.required')
    };
    this.chdRef.detectChanges();
    if (this.localInvestProject !== true) {
      this.inputAmountRef.triggerKeyup();
    }
  }

  @HostListener('document:keyup', ['$event']) onKeyupHandler(event: KeyboardEvent) {
    let valueCash = this.cashForm.value.cash.toString();
    valueCash = valueCash.replace(/\D/g, '');
    this.checkEneableBtn();
    this.inputValue = valueCash;
    this.totalMoney = Number(this.inputValue) + this.promotionalMoney;
    this.calculate();
    this.controlBtn();
    this.chdRef.detectChanges();
  }

  @HostListener('document:click', ['$event']) onClickHandler(event: KeyboardEvent) {
    let valueCash = this.cashForm.value.cash.toString();
    valueCash = valueCash.replace(/\D/g, '');
    this.checkEneableBtn();
    this.inputValue = valueCash;
    this.totalMoney = Number(this.inputValue) + this.promotionalMoney;
    this.calculate();
    this.controlBtn();
    this.chdRef.detectChanges();
  }

  sendValue() {
    let valueCash = this.cashForm.value.cash.toString();
    valueCash = valueCash.replace(/\D/g, '');
    this.amountValue.emit(Number(valueCash));
  }

  setTypeForm(numb) {
    this.method = numb;
    const obje = {
      cashForm: this.cashForm,
      methos: this.method
    };
    this.setPayType.emit(obje);
    let valueCash = this.cashForm.value.cash;
    valueCash.toString();
    valueCash = valueCash.replace(/\D/g, '');
    if (valueCash > 0 && this.method !== 0 && (this.minInvestmentAllowed < (Number(valueCash) + this.promotionalMoney))) {
      if (this.localInvestProject !== true) {
        this.sendXHR = 'colorFull';
      }
      this.chdRef.detectChanges();
    }
    this.controlBtn();
    this.chdRef.detectChanges();
  }

  controlBtn() {
    let valueCash = this.cashForm.value.cash.toString();
    valueCash = valueCash.replace(/\D/g, '');
    if (((((Number(valueCash) + this.data.contributed) > this.data.total) && !this.addPromoChecked) || (this.minInvestmentAllowed >= (Number(valueCash)))) && !this.hasToBookInvestment) {
      this.sendXHR = 'colorFull-disabled';
      console.log('A')
    } else if (this.addPromoChecked) {
      if (((Number(valueCash) + this.data.contributed + this.promotionalMoney) > this.data.total) || ((this.minInvestmentAllowed >= (Number(valueCash) + this.promotionalMoney)))) {
        this.sendXHR = 'colorFull-disabled';
        console.log('B')
      }
    }
    if ((this.method === 2 && ((this.data.moneyOutBalance - this.data.blockedMoney) < valueCash)) && !this.hasToBookInvestment) {
      this.sendXHR = 'colorFull-disabled';
      console.log('C')
    }
    // Aqui seteo a true para que me deje seguir
    if (this.localInvestProject === true && this.hasEconomicRights) {
      this.sendXHR = 'colorFull';
      console.log('D')
    }
    // Checkeo si se agrega un codigo promocional
    if (this.addPromoChecked) {
      if (Number(valueCash) < 500 || (Number(valueCash) >= 500 && Number(valueCash) < this.promotionalMoney)) {
        this.sendXHR = 'colorFull-disabled';
        console.log('E')
      }
    }
    // checkeo en reservas
    if (this.hasToBookInvestment) {
      if (this.data.total >= Number(valueCash)) {
        this.sendXHR = 'colorFull';
      } else {
        this.sendXHR = 'colorFull-disabled';
      }
      console.log('F')
    }
    this.chdRef.detectChanges();
  }

  invest() {
    console.log('llamo a invest')
    console.log(this.localInvestProject, 'this.localInvestProject')
    if (this.localInvestProject !== true) {
      let valueCash = this.cashForm.value.cash.toString();
      valueCash = valueCash.replace(/\D/g, '');
      this.isSubmit = true;
      console.log(this.cashForm.valid, 'this.cashForm.valid')
      console.log(Number(valueCash) % 1 === 0, 'Number(valueCash) % 1 === 0')
      console.log(this.method !== 0, 'this.method !== 0')
      console.log((Number(valueCash) + this.data.contributed) <= this.data.total, '(Number(valueCash) + this.data.contributed) <= this.data.total')
      console.log((this.method === 1 || (this.method === 2 && (this.data.moneyOutBalance - this.data.blockedMoney >= valueCash))), '(this.method === 1 || (this.method === 2 && (this.data.moneyOutBalance - this.data.blockedMoney >= valueCash)))')
      if (this.cashForm.valid && Number(valueCash) % 1 === 0 && this.method !== 0 &&
        (Number(valueCash) + this.data.contributed) <= this.data.total &&
        (
          this.method === 1 ||
          (this.method === 2 && !this.utils.checkEmptyField(this.currentStage) && this.currentStage.type !== 3) ||
          (this.method === 2 && ((this.data.moneyOutBalance - this.data.blockedMoney >= valueCash) && (this.utils.checkEmptyField(this.currentStage) || (!this.utils.checkEmptyField(this.currentStage) && this.currentStage.type === 3)))))
      ) {
        console.log('pasa el gran if')
        if (this.localInvestProject !== true) {
          this.sendXHR = 'colorFull';
        }
        this.disableInputs = true;
        if (this.cashForm.value.promotion !== '') {
          this.setCodePromotion.emit(this.cashForm.value.promotion);
        }
        const value = {
          invest: Number(valueCash),
          code: this.cashForm.value.promotion,
          mode: this.method,
          investmentStageId: this.currentStage && this.currentStage.id ? this.currentStage.id : null,
          projectPriorityGroupId: this.priorityGroupForUser && this.priorityGroupForUser.id ? this.priorityGroupForUser.id : null
        };
        console.log(value, 'antes de moneyToInvest')
        this.moneyToInvest.emit(value);
        if (this.currentProjectHasEmployeeAndClientInvestmentPhaseChecked) {
          this.subscribeToListOfVinculationInProject();
        }
      }
      if (Number(valueCash) % 1 !== 0) {
        this.errorCash = true;
      }
    } else {
      this.localInvestProject = false;
      this.sendXHR = 'colorFull-disabled';
    }
    this.chdRef.detectChanges();
    this.inputAmountRef.triggerKeyup();
  }

  openCode() {
    this.isOpen = !this.isOpen;
    if (this.isOpen === false) {
      this.symbol = ' + ';
    } else {
      this.symbol = ' - ';
    }
    this.chdRef.detectChanges();
  }

  calculate() {
    let valueCash = this.cashForm.value.cash.toString();
    valueCash = valueCash.replace(/\D/g, '');
    if (this.data.status === 14) {
      if (Number(valueCash) > this.data.max_allowed_amount_to_invest_for_user) {
        this.isSubmit = true;
        this.errorCash = true;
        this.errorMaxAmount = true;
      } else {
        this.isSubmit = false;
        this.errorCash = false;
        this.errorMaxAmount = false;
      }
    }
    if (Number(valueCash) && Number(valueCash) !== 0) {
      const moneyToCalculate = this.addPromoChecked && this.promotionalMoney > 0 ? this.totalMoney : valueCash;
      if (this.data.co2kwh && this.data.co2kwh !== 0 && this.data.co2kwh !== null && this.data.co2kwh !== undefined) {
        this.prevent = this.data.power * 1500 * this.data.co2kwh * this.data.term * Number(moneyToCalculate) / this.data.total;
      } else {
        this.prevent = this.data.power * 1500 * 0.1 * this.data.term * Number(moneyToCalculate) / this.data.total;
      }
    } else {
      this.prevent = 0;
    }
    if (Number(valueCash) > (this.data.total - this.data.contributed)) {
      this.moreTanAvailable = true;
    } else {
      this.moreTanAvailable = false;
    }
    this.calculateSocialCap();
    if (this.data['id'] === 161 && Number(valueCash) >= 24000) {
      this.showStatkaftAdvise = true;
    } else {
      this.showStatkaftAdvise = false;
    }
    this.controlBtn();
    this.chdRef.detectChanges();
  }

  checkValue(value) {
    if (value && value !== null && value !== undefined && value !== '') {
      return true;
    }
    return false;
  }

  changeSharedType(value) {
    this.sharedValue = this.sharedForm.value.shared;
    if (this.sharedValue !== undefined) {
      this.selectItm = this.sharedValue;
      for (let i = 0; i < this.data.economicRights.length; i++) {
        if (i === this.sharedValue) {
          this.shareInfo = this.data.economicRights[i];
          this.shareInfo.repurchase = this.shareInfo.description.includes('B') ? true : false;
          const model = {
            id: this.data.economicRights[i].id,
            prof: this.data.economicRights[i].profitability,
          };
          this.localInvestIdEvent.emit(model);
        }
      }
      this.sendXHR = 'colorFull';
    }
    this.chdRef.detectChanges();
  }

  prev() {
    this.localInvestProject = true;
    this.sendXHR = 'colorFull';
    this.chdRef.detectChanges();
  }

  checkAddPromo() {
    this.addPromoChecked = !this.addPromoChecked;
    const payload = {
      promos: this.pendingPromos,
      add: this.addPromoChecked
    };
    this.addPromotionalMoneyEvent.emit(payload);
    this.biometricService.makeMobileVibrate();
    this.chdRef.detectChanges();
  }

  openTest() {
    this.openTestEvent.emit();
    this.chdRef.detectChanges();
  }

  calculateSocialCap() {
    if (this.profile.isExperiencedInvestor !== null) {
      let socialCapLimit;
      const value = Number(this.cashForm.value.cash.replaceAll('.', ''));
      if (this.profile.profileType === 1) {
        socialCapLimit = (this.profile.annualGrossIncome + this.profile.finantialPatrimony) * 0.05;
      } else {
        socialCapLimit = (this.profile.rangeOwnResources + this.profile.rangeTurnover + this.profile.rangebalance) * 0.05;
      }
      if (socialCapLimit < value) {
        this.showAdvice = true;
      } else {
        this.showAdvice = false;
      }
    }
    this.chdRef.detectChanges();
  }

  checkPromotionalCode(code?) {
    this.refCode = code !== null && code !== undefined ? code : this.cashForm.controls.promotion.value;
    const refCode2 = this.refCode;
    setTimeout(() => {
      if (this.refCode === refCode2 && this.refCode !== '' && this.refCode.length > 4) {
        this.profileService.getRefCodeValidation(this.refCode).subscribe(resp => {
          const referred = resp.referred;
          const referralLevels = this.utils.getReferralLevels();
          const clanAmount = this.cashForm.controls.cash.value.replace(/\./g, '');
          const amount = parseFloat(clanAmount);
          function findAmountsByNumber(number) {
            for (const range of referralLevels) {
              if (number >= range.from && (range.to === null || number <= range.to)) {
                return { yourAmount: range.yourAmount, friendAmount: range.friendAmount };
              }
            }
            return null;
          }
          const values = findAmountsByNumber(amount);
          this.refMessage = this.translate.instant('INVEST.CODE_TEXT', { referred: referred, friendAmount: values.friendAmount, yourAmount: values.yourAmount });
          this.chdRef.detectChanges();
        }, error => {
          this.refMessage = null;
          this.chdRef.detectChanges();
        });
      }
      this.chdRef.detectChanges();
    }, 500);
    this.chdRef.detectChanges();
  }

  checkEneableBtn() {
    let valueCash = this.cashForm.value.cash.toString();
    valueCash = valueCash.replace(/\D/g, '');
    if (this.cashForm.valid && this.method !== 0 && (this.minInvestmentAllowed < (Number(this.cashForm.value.cash) + this.promotionalMoney))
      && (this.method === 1 || (this.method === 2 && (this.data.moneyOutBalance - this.data.blockedMoney >= valueCash)))) {
      this.sendXHR = 'colorFull';
      if (this.isForeingInvestor && this.data['id'] === 161) {
        this.sendXHR = 'colorFull-disabled';
      }
    } else {
      if (!this.hasToBookInvestment) {
        this.sendXHR = 'colorFull-disabled';
      } else {
        if (this.data.total >= (Number(this.cashForm.value.cash))) {
          this.sendXHR = 'colorFull';
        } else {
          this.sendXHR = 'colorFull-disabled';
        }
      }
    }
    this.chdRef.detectChanges();
  }

  checkCurrentProjectHasEmployeeAndClientInvestmentPhaseChecked() {
    this.currentProjectHasEmployeeAndClientInvestmentPhaseChecked = !this.currentProjectHasEmployeeAndClientInvestmentPhaseChecked;
    if (this.currentProjectHasEmployeeAndClientInvestmentPhaseChecked) {
      const modalParams = {
        image: 5,
        text: this.translate.instant('INFO.CHECK_VINCULATION'),
        btnList: [
          {
            type: 'primaryDark',
            index: 1,
            title: this.translate.instant('AUTOINVEST.FOOTER.NEXT'),
          }
        ],
      };

      this.alertService.showModal(OveralMessageComponent, modalParams, '', '', true).subscribe((modal: any) => {
        modal.getChildComponent().subscribe((componentRef: OveralMessageComponent) => {
          componentRef.btnEvent.subscribe((resp) => {
            this.alertService.removeModal();
          });
        });
        modal.activeCross().subscribe();
        modal.onClose().subscribe();
      });
    }
    this.chdRef.detectChanges();
  }

  getCurrentProjectHasEmployeeAndClientInvestmentPhaseText() {
    if (this.currentProjectHasEmployeeAndClientInvestmentPhase['checkInvestmentMessage'][this.translate.currentLang]) {
      return this.currentProjectHasEmployeeAndClientInvestmentPhase['checkInvestmentMessage'][this.translate.currentLang];
    } else if (this.currentProjectHasEmployeeAndClientInvestmentPhase['checkInvestmentMessage']['es']) {
      return this.currentProjectHasEmployeeAndClientInvestmentPhase['checkInvestmentMessage']['es'];
    }
    return 'Confirmo que tengo vinculación directa con el proyecto.';
  }

  subscribeToListOfVinculationInProject() {
    const model = {
      data: {
        username: this.profile.username,
        projectId: this.currentProjectHasEmployeeAndClientInvestmentPhase.projectId,
        projectName: this.currentProjectHasEmployeeAndClientInvestmentPhase.projectName,
        step: 'invest',
        name: this.profile.name
      }
    }
    this.strapiService.saveVinculationUserAndProject(model).subscribe(() => { this.chdRef.detectChanges() });
    this.chdRef.detectChanges();
  }

  checkMyIban() {
    this.closeAndCheckIbanEvent.emit();
    this.chdRef.detectChanges();
  }

  setStagesInfo() {
    if (this.data.investmentStages && this.data.investmentStages.length > 0) {
      const now = new Date();
      for (let i = 0; i < this.data.investmentStages.length; i++) {
        const stage = this.data.investmentStages[i];
        const nextStage = this.data.investmentStages[i + 1];
        const startDate = new Date(stage.start_date);

        const isCurrentStage = (now >= startDate) && (!nextStage || now < new Date(nextStage.start_date));

        if (isCurrentStage) {
          console.log(isCurrentStage, 'isCurrentStage');
          this.currentStage = stage;
          if (stage.type === 1) {
            this.hasToBookInvestment = true;
            this.hasToBookInvestmentEvent.emit(this.hasToBookInvestment);
          } else if (stage.type === 2) {
            this.isPriorityGroupStep = true;
            this.hasToBookInvestment = true;
            this.hasToBookInvestmentEvent.emit(this.hasToBookInvestment);
          }
          if (this.data.priority_groups && this.data.priority_groups.length > 0) {
            // Filtrar los grupos a los que pertenece el usuario
            const userGroups = this.data.priority_groups.filter((pg: any) => pg.isEnabledForUser === true);
            console.log(userGroups, 'userGroups');
            if (userGroups.length > 0) {
              // Seleccionar el grupo con la prioridad más alta (número más bajo)
              const userGroup = userGroups.reduce((prev: any, current: any) => {
                return (prev.priority < current.priority) ? prev : current;
              });
              console.log(userGroup, 'userGroup (highest priority)');
              if (stage.type !== 1) {
                this.hasToBookInvestment = false;
                this.hasToBookInvestmentEvent.emit(this.hasToBookInvestment);
              }
              this.userValidatedInPriorityGroup = true;
              this.userValidatedInPriorityGroupEvent.emit(this.userValidatedInPriorityGroup);
              this.priorityGroupForUser = userGroup;
            }
          }
        }
      }
    }
    console.log(this.hasToBookInvestment, 'hasToBookInvestment');
    console.log(this.isPriorityGroupStep, 'isPriorityGroupStep');
    console.log(this.userValidatedInPriorityGroup, 'userValidatedInPriorityGroup');
    console.log(this.priorityGroupForUser, 'priorityGroupForUser');
    console.log(this.currentStage, 'currentStage');
    this.chdRef.detectChanges();
  }
}
